import { Box, Typography, Button, CircularProgress } from '@mui/material'
import logo from './../resources/freeBILL_logo.png'
import { Form, LoginFormClasses, minLength, required, PasswordInput, useNotify, useSafeSetState, useTranslate, maxLength } from 'react-admin'
import { apiService } from '../apiService'
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ChangeEvent } from 'react';
import { passwordStrength } from './passwordStrength';

export const ResetPassword = () => {
  
  const translate = useTranslate()
  const [searchParams] = useSearchParams()
  const notify = useNotify()
  const navigate = useNavigate()
  const [loading, setLoading] = useSafeSetState(false)
  const [password, setPassword] = useSafeSetState<string | undefined>()

  const validatePasswordRepeat = (value: any, allValues: any) => {
    if (value !== allValues.password)
      return "Die Passwörter sind nicht gleich."
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  const submit = async(values: any) => {
    setLoading(true);
    try {
      var resetHash = searchParams.get("resetHash")
      await apiService.UsersApi.resetPassword({resetPasswordCommand: {resetHash: resetHash, newPassword: values.password}})
      setLoading(false)
      notify(translate("resources.authentication.resetPassword.feedback"), {type: "success", autoHideDuration: 6000})
      navigate("/#/login")
    } catch (error:any) {
      setLoading(false);
      notify(
        typeof error === 'string'
            ? error
            : typeof error === 'undefined' || !error.message
            ? 'ra.auth.sign_in_error'
            : error.message,
        {
            type: 'error',
            messageArgs: {
                _:
                    typeof error === 'string'
                        ? error
                        : error && error.message
                        ? error.message
                        : undefined,
            },
        }
      )
    }
  }

  return (
    <Box p={5} display={"flex"} height={450} width={"100%"} sx={{backgroundColor: "#f3f3fa"}} justifyContent={"center"}>
      <Box width={{xs: "100%", sm: "60%", md: "30%"}}>
        <Box display={"flex"} justifyContent={"center"} >
          <Box 
            component={"img"}
            sx={{height: 35}}
            src={logo}
            display={{xs: "none", sm: "block"}}
          />
        </Box>
        <Box py={2} display={"flex"} justifyContent={"center"}>
          <Typography variant='h6'>{translate("resources.authentication.resetPassword.title")}</Typography>
        </Box>
        <Box py={2}>
          <Typography variant='body2' >
          {translate("resources.authentication.resetPassword.description")}
          </Typography>
        </Box>
        <Box py={2}>
          <Form
            onSubmit={submit}
            mode="onChange"
            noValidate
          >
            <PasswordInput 
              autoFocus
              source="password"
              label={"Neues Passwort"}
              autoComplete="password"
              validate={[required(), minLength(8), maxLength(100)]}
              onChange={handleChange}
              fullWidth
              helperText={password ? `Passwortstärke: ${passwordStrength(password).value}` : undefined}
            />
            <PasswordInput 
              source="passwordRepeat"
              label={"Passwort wiederholen"}
              autoComplete="password"
              validate={[required(), validatePasswordRepeat]}
              fullWidth
            />
            <Button
                  variant={"contained"}
                  type="submit"
                  disabled={loading}
                  fullWidth
                  className={LoginFormClasses.button}
                  size='small'
              >
                  {loading ? (
                      <CircularProgress
                          className={LoginFormClasses.icon}
                          size={19}
                          thickness={3}
                      />
                  ) : (
                    translate("resources.authentication.resetPassword.action")
                  )}
              </Button>
          </Form>
        </Box>
      </Box>  
    </Box>
  )
}
